import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const LockerListPage = lazy(() => import('src/pages/locker/list'));
const LockerDetailPage = lazy(() => import('src/pages/locker/detail'));

// ----------------------------------------------------------------------

export const lockerRoutes = [
  {
    path: 'locker',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <LockerListPage />, index: true },
      { path: 'packages', element: <LockerListPage /> },
      { path: 'packages/:id', element: <LockerDetailPage /> },
    ],
  },
];
